// $(document).ready(function() {
//         var button = $('.metafield_color').closest('.product__details').find('.product-form__cart-submit');
//    setTimeout(function(){
//     button.prop('disabled', true);
// },500)
//         $('.metafield_color').change(function() {
//             if ($(this).val() == 'select options') {
//                 button.prop('disabled', true);
//             } else {
//                 button.prop('disabled', false);
//             }
//         }); 
//     });


$('.COLOUR').click(function(){
    $('.palette2').toggleClass("remove_card")
})



// var new_val = $('.round').text();
// console.log(new_val);
// $('.round')
//     .parents(".product__details")
//     .find("input.metas-9")
//     .attr("value", new_val);

var one_val = $(".shapess option:selected").val();
  var existing_val = $(this)
    .parents(".product__details")
    .find("input.metas-5")
    .attr("value");

  // Check if the selected value is different from the existing value in the cart
  if (one_val !== existing_val) {
    $(this)
      .parents(".product__details")
      .find("input.metas-5")
      .attr("value", one_val);
    $(".swatch_name_1").removeClass("active");
    $(this).find(":selected").addClass("active");
  }


$(".shapess").change(function () {
  var one_val = $(".shapess option:selected").val();
  var existing_val = $(this)
    .parents(".product__details")
    .find("input.metas-5")
    .attr("value");

  // Check if the selected value is different from the existing value in the cart
  if (one_val !== existing_val) {
    $(this)
      .parents(".product__details")
      .find("input.metas-5")
      .attr("value", one_val);
    $(".swatch_name_1").removeClass("active");
    $(this).find(":selected").addClass("active");
  }
});


// $(document).ready(function(){
//     // Attach a click event handler to the button with the label "4 inch / serves 2-4"
//     $('button[data-option-handle="4-inch-serves-2-4--0"]').click(function() {
//         var new_val = $('.round').text();
//         console.log(new_val);
//         $('.round')
//             .parents(".product__details")
//             .find("input.metas-9")
//             .attr("value", new_val);
//     });

//     // Attach change event handler to the select element with class "shapess"
//     $(".shapess").change(function () {
//         var one_val = $(".shapess option:selected").val();
//         var existing_val = $(this)
//             .parents(".product__details")
//             .find("input.metas-5")
//             .attr("value");

//         // Check if there are already shapes in the cart
//         if (existing_val === "") {
//             $(this)
//                 .parents(".product__details")
//                 .find("input.metas-5")
//                 .attr("value", one_val);
//             $(".swatch_name_1").removeClass("active");
//             $(this).find(":selected").addClass("active");
//         }
//     });
// });




$(".parent_svg").on("click", function () {
  var button = $(".metafield_color")
    .closest(".product__details")
    .find(".product-form__cart-submit");
  button.prop("disabled", true);
});
$(".parent_man").on("click", function () {
  var button = $(".metafield_color")
    .closest(".product__details")
    .find(".product-form__cart-submit");
  // if($('.parent_man').find('.color-yellow').length) {
  //     button.prop('disabled', false);
  //     if($('.parent_svg').find('.combined_parent').find('.color-yellow').length){
  //         button.prop('disabled', true);
  //     }else{
  //        button.prop('disabled', false);
  //     }
  // } else {
  //      button.prop('disabled', false);
  // }
});
var b = $(".product__color-chips button.selected").attr("aria-label");
if (b == "4 inch / serves 2-4") {
  $(".shap_option").hide();
  $(".round_option").show();
} else {
  $(".shap_option").show();
  $(".round_option").hide();
}

$(".product__color-chips button").click(function () {
  var a = $(this).attr("aria-label");
  if (a == "4 inch / serves 2-4") {
    $(".shap_option").hide();
    $(".round_option").show();
  } else {
    $(".shap_option").show();
    $(".round_option").hide();
  }
});
$(".shapess").change(function () {
  var selectedValue = $(this).val();
  var button = $(this)
    .closest(".product__details")
    .find(".product-form__cart-submit");

  if (selectedValue == "heart") {
    $(".product__color-chips.dynamic-variant-input-wrap button").each(
      function () {
        var value = $(this).attr("data-option-value");
        if (value == "4 inch / serves 2-4") {
          $(this).addClass("disabled");
        }
      }
    );

    button.prop("disabled", true);
  } else {
    // button.removeClass('dis_active');
    $(".product__color-chips.dynamic-variant-input-wrap button").each(
      function () {
        var value = $(this).attr("data-option-value");
        if (value == "4 inch / serves 2-4") {
          $(this).removeClass("disabled");
        }
      }
    );
    button.prop("disabled", false);
  }
});



$(document).ready(function () {
  // Get today's date
  var today = new Date();

  // Set the target date to two days from today
  var targetDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() + 2,
    0,
    0,
    0
  );

  function updateCountdown() {
    var now = new Date();

    var timeRemaining = targetDate - now;

    var days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
    var hours = Math.floor(
      (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    var minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

    $(".countdown-timmer__amount[data-days]").text(days);
    $(".countdown-timmer__amount[data-hours]").text(hours);
    $(".countdown-timmer__amount[data-minutes]").text(minutes);
    $(".countdown-timmer__amount[data-seconds]").text(seconds);
  }

  var countdownInterval = setInterval(updateCountdown, 1000);
});
//   $('.swatch_name').change(function () {
//     var one_val = $('.color-swatch.one_pos select option:selected').val();
//     var two_val = $('.color-swatch.two_pos select option:selected').val();
//     var three_val = $('.color-swatch.three_pos select option:selected').val();
//     $(this).parents('.product__details').find('input.metas-1').attr('value',one_val);
//     $(this).parents('.product__details').find('input.metas-2').attr('value',two_val);
//     $(this).parents('.product__details').find('input.metas-3').attr('value',three_val);
//     $('.swatch_name_1').removeClass('active');
//     $(this).find(':selected').addClass('active');
// });

//   $('.com').click(function () {
//     var one_val = $('.color-swatch.one_pos').find('.combined-swatch-container .main-color-value2').text();
//     var two_val = $('.color-swatch.two_pos').find('.combined-swatch-container .main-color-value1').text();
//     var three_val = $('.color-swatch.three_pos').find('.combined-swatch-container .main-color-value').text();
//     $(this).parents('.product__details').find('input.metas-1').attr('value',one_val);
//     $(this).parents('.product__details').find('input.metas-2').attr('value',two_val);
//     $(this).parents('.product__details').find('input.metas-3').attr('value',three_val);
//     $('.swatch_name_1').removeClass('active');
//     $(this).find(':selected').addClass('active');
// });
$(".prot_cart").click(function () {
  $(this)
    .parents("body")
    .find(".product__details button.product-form__cart-submit")
    .click();
});

$(window).scroll(function () {
  var scroll = $(window).scrollTop();

  if (scroll >= 1050) {
    $(".prooo").addClass("darkHeader");
  } else if (scroll <= 400) {
    $(".prooo").addClass("darkHeader");
  } else {
    $(".prooo").removeClass("darkHeader");
  }
});

// $(document).ready(function () {
//     var one_val = $('.shapess option:selected').val();

//     $('.shapess').parents('.product__details').find('input.metas-5').attr('value', one_val);
//     $('.swatch_name_1').removeClass('active');
//     $('.shapess :selected').addClass('active');

// });



$(".colorPaletteContainer").on("click", ".colorBox", function () {
  var new_val = $(this).data("colorName");
  $(this).addClass('active').siblings().removeClass('active');
  $(this)
    .parents(".product__details")
    .find("input.metas-6")
    .attr("value", new_val);
    setTimeout(function() {
    var allActive = $('.colorPaletteContainer .colorBox.active').length;
    if(allActive){
    console.log('all')
    $('button.product-form__cart-submit, .buy-it-now a').removeClass('pointer-events');
    $('button.product-form__cart-submit').attr('disabled',false);
    }
    else{
    console.log('not-all')
    $('button.product-form__cart-submit').addClass('pointer-events');
    }
    }, 1000);
});

$(".color_swatches").click(function () {
  var textColor = $(this).find(".text_color").text();
  $(this)
    .parents(".product__details")
    .find("input.metas-7")
    .attr("value", textColor);
});

$(".parent_man").click(function () {
  $(".palette1").toggleClass("activated"); // Toggle the class 'activated' on elements with class 'palette1'
});
$(".parent_man2").click(function () {
  $(".palette4").toggleClass("activated");
});
$(".parent_man3").click(function () {
  console.log("hello");
  $(".palette3").toggleClass("activated");
});

$(".combined_parent").click(function () {
  $(".combined_parent").removeClass("color-yellow");
  $(this).addClass("color-yellow");
   $(this).parents(".check_test").addClass("active_option");
});
// $(".colorlistt").click(function () {
//   var val = $(this).parents('.parent_man').find('.combined-option').attr('value');
//  console.log(val)
//  var val1 = $(this).parents('.parent_man2').find('.combined-option').attr('value');
//    console.log(val1)
//    $(this).parents(".product__details").find('input.metas-1.base').val(val1);
//   $(this).parents(".product__details").find('input.metas-2.main').val(val);
//   $(this).parents('.parent_man2').find('.main3 .choose_color').html(val);
//   $(".colorlistt").removeClass("color-yellow");
//    $(this).parents(".check_test").addClass("active_option");
//   $(this).addClass("color-yellow");
//    setTimeout(function() {
//   var allActive = $('.check_test').length === $('.check_test.active_option').length;
//    if(allActive){
//     console.log('all')
//   $('button.product-form__cart-submit,.buy-it-now a').removeClass('pointer-events');
//    $('button.product-form__cart-submit').attr('disabled',false);
//   }
//   else{
//   console.log('not-all')
//   $('button.product-form__cart-submit').addClass('pointer-events');
//   }
// }, 1000);
// });

$(".palette2  .combined_parent1 ").click(function () {
  var new_val = $(this).children(".hide_color1").text();
console.log(new_val)
   $(this).parents(".check_test").addClass("active_option");
  $(".main3").text(new_val);
  $(this)
    .parents(".product__details")
    .find("input.metas-1.base")
    .attr("value", new_val);
     setTimeout(function() {
  var allActive = $('.check_test').length === $('.check_test.active_option').length;
   if(allActive){
   
  $('button.product-form__cart-submit, .buy-it-now a').removeClass('pointer-events');
  $('button.product-form__cart-submit').attr('disabled',false);
  }
  else{
 
  $('button.product-form__cart-submit').addClass('pointer-events');
  }
}, 1000);
});
$(".parent_man .combined_parent").click(function () {
  var new_val1 = $(this).children(".hide_color1").text();
console.log(new_val1)
   $(this).parents(".check_test").addClass("active_option");
  $(".main_1").text(new_val1);
  $(this)
    .parents(".product__details")
    .find("input.metas-2.main")
    .attr("value", new_val1);
       setTimeout(function() {
  var allActive = $('.check_test').length === $('.check_test.active_option').length;
   if(allActive){
   
  $('button.product-form__cart-submit, .buy-it-now a').removeClass('pointer-events');
  $('button.product-form__cart-submit').attr('disabled',false);
  }
  else{
 
  $('button.product-form__cart-submit').addClass('pointer-events');
  }
}, 1000);
});
$(".palette3 .combined_parent").click(function () {
  var new_val = $(this).children(".hide_color1").text();
   $(this).parents(".check_test").addClass("active_option");
  $(".main2").text(new_val);
  $(this)
    .parents(".product__details")
    .find("input.metas-3")
    .attr("value", new_val);

       setTimeout(function() {
  var allActive = $('.check_test').length === $('.check_test.active_option').length;
   if(allActive){
   
  $('button.product-form__cart-submit, .buy-it-now a').removeClass('pointer-events');
  $('button.product-form__cart-submit').attr('disabled',false);
  }
  else{
 
  $('button.product-form__cart-submit').addClass('pointer-events');
  }
}, 1000);
});



$(".combined_parent1 .hide_color1").click(function () {
  var color_val = $(this).text();
  $(".main3").text(color_val);
});

// color palette onclick
$(document).ready(function(){
    
    $(".palette_img").click(function(){
     
      $(".comb_pelate").hide();
      $(".comb_pelate").removeClass('active-pelate');
      var index = $(this).index();
      
      $(".comb_pelate").eq(index).show();
      $(".comb_pelate").eq(index).addClass('active-pelate');
    });
  });


// change value on click this
$(".comb-option").click(function(){
      var value = $(this).attr('value');
      console.log(value); // You can do whatever you want with the value
      // For example, you can set it to a div with class "valcolor"
      $(".valcolor").text(value);
    });
// // display color palette
$(document).ready(function(){
    $('.COLOUR').click(function(){
      $('.colour_guide_tab').toggleClass("plate_display_guide");
    });
  });

// with cross display none
$('.cross-icon').click(function(){
    $('.new_palette-parent').removeClass("plate_display");
});

$('.icon_cross').click(function(){
    $('.palette2').removeClass("remove_card");
});
$('.icon_crose').click(function(){
    $('.colour_guide_tab').removeClass("plate_display_guide")
});

$(document).ready(function(){
    $('.COLOUR-PALETTE').click(function(){
      $('.guide_image').toggleClass("plate_display_guide_re");
    });
  });

$('.icon_crose_1').click(function(){
    $('.guide_image').removeClass("plate_display_guide_re")
});